import { useCurrentWallet } from '@plug-core/state'
import { Messenger } from '@plug-core/interfaces/messenger'

export const handleWalletSwitch = ({ inpageMessenger }: { inpageMessenger: Messenger }) => {
  useCurrentWallet.subscribe(({ currentWallet }, { currentWallet: oldWallet }) => {
    if (!!oldWallet && oldWallet !== currentWallet) {
      inpageMessenger.send('principal-changed', { currentWallet })
    }
  })
}
